//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { QDialog } from "quasar";
import AQButton from "../AQButton/AQButton.vue";

export default {
    name: "AQDialog",
    components: {
        QDialog,
        AQButton
    },
    props: {
        value: { type: Boolean, required: false, default: false },
        title: { type: String, required: true, default: "" },
        message: { type: String, required: false, default: "" },
        secondaryMessage: { type: String, required: false, default: "" },
        contentClass: { type: String, required: false, default: "" },
        cssClass: { type: String, required: false, default: "" },
        cancelLabel: { type: String, required: false, default() { return this.$t("generic.cancel"); } },
        confirmLabel: { type: String, required: false, default() { return this.$t("generic.confirm"); } },
        secondaryActionLabel: { type: String, required: false, default() { return this.$t("generic.discardAndContinue"); } },
        atId: { type: String, required: false, default: "" },
        isDeleteAlert: { type: Boolean, required: false, default: false },
        isInfo: { type: Boolean, required: false, default: false },
        hasAction: { type: Boolean, required: false, default: false },
        hasThreeBtn: { type: Boolean, required: false, default: false },
        actionText: { type: String, required: false, default() { return this.$t("dialogComponent.exportBtn"); } },
        leftActionIcon: { type: String, required: false, default: "folder" },
        rightActionIcon: { type: String, required: false, default: "download" },
        disableBtn: { type: Boolean, required: false, default: false },
        preventClose: { type: Boolean, required: false, default: false }

    },
    data() {
        return {
        };
    },
    computed: {
        getAtId() {
            return this.atId ? `${this.atId}-dialog-id` : "dialog-id";
        }
    },
    methods: {
        setValue(show) {
            if (show) {
                this.$refs.okBtn.$el.blur();
            }
            this.$emit("input", show);
        },
        okEvent() {
            if (!this.preventClose) {
                this.setValue(false);
            }
            this.$emit("ok");
        },
        cancelEvent() {
            this.setValue(false);
            this.$emit("cancel");
        },
        secondaryAction() {
            this.setValue(false);
            this.$emit("secondaryAction");
        },
        triggerAction() {
            this.$emit("actionTriggered");
        }

    }
};
